import React, { useState } from 'react';
import {
  Box,
  Button,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
} from '@mui/material';
import { Delete as DeleteIcon, Edit as EditIcon } from '@mui/icons-material';
import { ExpandMore, ChevronRight } from '@mui/icons-material';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import RoleDetails from './RoleDetails';
import RoleForm from './RoleForm';
import { useDispatch } from 'react-redux';
import { updateRoleToFirebase } from 'src/slices/authSlice';
import CreateNewItem from './CreateNewItem';



interface RoleGroupManagerProps {
  brandSecurity: any;
  
}

const RoleGroupManager: React.FC<RoleGroupManagerProps> = ({
    brandSecurity
}) => {
    const dispatch = useDispatch()
    const groups = Object.keys(brandSecurity.roleGroups).map(key => ({
        id: key,
        ...brandSecurity.roleGroups[key],
        roles: Object.keys(brandSecurity.roleGroups[key].roles).map(roleId => ({
          id: roleId,
          
          ...brandSecurity.roles[roleId], // Map role ID to its details
          permissions : Object.keys(brandSecurity.roles[roleId].permissions),
          brandSecurity:  brandSecurity
        }))
      }));
  const [selectedGroup, setSelectedGroup] = useState<any | null>(groups[0]);
  const [lastknownGroup, setLastKnownGroup] = useState<any | null>(groups[0]);
  const [selectedRole, setSelectedRole] = useState<any | null>(null);
  const [lastknownRole, setLastknownRole] = useState<any | null>(null);
  const [isEditRole, setIsEditRole] = useState<any | null>(null);
  const [isEditRoleGroup, setIsEditRoleGroup] = useState<any | null>(null);
  const onEditGroup = (group: any) => {
    setSelectedGroup(null);
    setSelectedRole(null);
    setIsEditRoleGroup(selectedGroup)
    setIsEditRole(null)
  };
 const onDeleteGroup =  (groupId: string) => {

 };
  const handleSelectGroup = (group: any) => {
    setSelectedGroup(group);
    setSelectedRole(null);
    setIsEditRoleGroup(null)
    setIsEditRole(null)
  };
  const handleSelectRole = (role: any) => {
    setSelectedRole(role);
    setSelectedGroup(null);
    setIsEditRoleGroup(null)
    setIsEditRole(null)
  };

  const handleDelete = () => {
    console.log('Delete role:', selectedRole);

  };

  const handleEdit = (isNew= false, role) => {
    console.log('Edit role:', selectedRole);
    setSelectedGroup(null);
    if(!isNew)
    setLastknownRole(role)
    setIsEditRoleGroup(null)
    setIsEditRole(isNew? {}: role)
    setSelectedRole(null);
  };

  const onSaveRole = (id,data) => {
    handleSelectRole(lastknownRole)
    dispatch(updateRoleToFirebase({id, tab: 1, data}))
  }

  return (
    <Box display="flex" height="100%">
      {/* Left Sidebar */}
      <Box
        width="25%"
        borderRight="1px solid #ddd"
        display="flex"
        flexDirection="column"
      >
        <CreateNewItem onNewRole={()=>handleEdit(true, {})}  onNewGroup={()=>onEditGroup({})}/>
        {/* <Button
          variant="text"
          color="primary"
          startIcon={<EditIcon />}
          sx={{ mb: 2, mt: 2 }}
          onClick={() => onEditGroup({ id: '', name: 'New Group', roles: [] })}
        >
          + Create new item
        </Button> */}
        <SimpleTreeView
        sx={{padding:'10px'}}
         // onNodeSelect={(event, nodeId) => handleSelectGroup(nodeId)}
        >
          {groups.map((group) => (
            <TreeItem
                  key={group.id}
                  itemId={group.id} 
                  onClick={() => handleSelectGroup(group)}
                  label={<Box display="flex" alignItems="center" justifyContent="space-between" padding='10px'>
                      <Typography>{group.name}</Typography>
                      <Typography variant="body2" color="textSecondary">
                          {group.roles.length}
                      </Typography>
                  </Box>}            
                  >

                {group.roles.map((role) => (
                            <TreeItem
                                key={role.id}
                                itemId={role.id} 
                                onClick={()=> handleSelectRole(role)}
                                label={<Box display="flex" alignItems="center" justifyContent="space-between">
                                    <Typography>{role.name}</Typography>
                                    
                                </Box>}            
                                />))}


                  </TreeItem>
          ))}
        </SimpleTreeView>
      </Box>

      {/* Right Panel */}
      <Box flex={1} padding={2}>
        {selectedGroup && (
          <>
            <Typography variant="h6" gutterBottom>
              {selectedGroup.name}
            </Typography>
            <Typography variant="body2" gutterBottom>
              {selectedGroup.roles.length} assigned roles
            </Typography>
            <List>
              {selectedGroup.roles.map((role) => (
                <ListItem
                  key={role.id}
                  secondaryAction={
                    <IconButton edge="end" onClick={() => console.log(`Edit Role ${role.id}`)}>
                      <EditIcon />
                    </IconButton>
                  }
                >
                  <ListItemIcon>
                    <Typography variant="body2" color="primary">
                      {role.name}
                    </Typography>
                  </ListItemIcon>
                </ListItem>
              ))}
            </List>
            <Box display="flex" justifyContent="space-between" mt={4}>
              <Button
                variant="outlined"
                color="error"
                startIcon={<DeleteIcon />}
                onClick={() => onDeleteGroup(selectedGroup.id)}
              >
                Delete
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => onEditGroup(selectedGroup)}
              >
                Edit Role Group
              </Button>
            </Box>
          </>
        ) }
        {
            selectedRole &&  <>
                <RoleDetails selectedRole={selectedRole} onDelete={handleDelete} onEdit={handleEdit}/>
            </>
        }
        {
            isEditRole && <RoleForm roleData={isEditRole}  permissions={brandSecurity.permissions} 
            onSave={(id,data) =>onSaveRole(id, data)} onCancel={()=> console.log("cancel")}/>
        }
      </Box>
    </Box>
  );
};

export default RoleGroupManager;
